import {SET_GLOBAL_MASK} from '../../constants';

export type SetGlobalMaskAction = {
    /**
     * The action type
     */
    type : typeof SET_GLOBAL_MASK;

    /**
     * The name of the mask
     */
    name : string;
}

/**
 * @memberOf! Actions
 *
 * @param {String} name           The name of the mask
 *
 * @return {SetGlobalMaskAction}
 */
const setGlobalMask = ( name : string ) : SetGlobalMaskAction => {
    return {
        type: SET_GLOBAL_MASK,
        name
    };
}
export type SetGlobalMask = typeof setGlobalMask;

export default setGlobalMask;
